import endpoints from '@app/src/api/endpoints'
import { FetchKey } from '@app/src/api/fetchHooks'
import { useUpdateResource } from '@app/src/api/updateHooks'
import useErrorNotification from '@app/src/hooks/errorNotification'
import { useQueryClient } from '@tanstack/react-query'
import type { AssignAccessorModel, Request } from '@app/src/types/resourceExplorer'

export type UpdateSharingOptions = {
  requestId: number
  organizationIdsToShareWith: number[]
  isSharedWithTemplateAuthorizedOrgs?: boolean
}

export const useUpdateSharing = () => {
  const { mutateAsync: mutateShareAsync, isPending: isUpdatingSharing } = useUpdateResource<
    Request,
    AssignAccessorModel
  >()
  const queryClient = useQueryClient()
  const { showErrorNotification } = useErrorNotification()

  const updateSharing = async ({
    isSharedWithTemplateAuthorizedOrgs = false,
    organizationIdsToShareWith,
    requestId,
  }: UpdateSharingOptions) => {
    await mutateShareAsync(
      {
        url: endpoints.assignAccessors,
        body: {
          requestId: requestId,
          accessorOrganizationIds: organizationIdsToShareWith,
          isSharedWithTemplateAuthorizedOrgs: isSharedWithTemplateAuthorizedOrgs,
        },
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: [FetchKey.Response] })
          queryClient.invalidateQueries({ queryKey: [FetchKey.ResponseSharing, Number(requestId)] })
          queryClient.invalidateQueries({ queryKey: [FetchKey.RequestPerPeriod] })
          queryClient.invalidateQueries({ queryKey: [FetchKey.InquiryOpenRequests] })
        },
        onError: error => {
          showErrorNotification({ requestError: error })
        },
      },
    )
  }

  return { updateSharing, isUpdatingSharing }
}
